import { v4 as uuidv4 } from "uuid";
import { scopedLocalStorage } from "../utils/storage";
export function getSessionId(): string {
  const stored = scopedLocalStorage.getItem("session_info");
  let session_id = "";
  let now = Date.now();

  if (stored) {
    const { id, timestamp } = JSON.parse(stored);
    const sessionAge = now - timestamp;
    const twelveHours = 12 * 60 * 60 * 1000;

    if (sessionAge < twelveHours) {
      session_id = id;
    } else {
      scopedLocalStorage.removeItem("session_info");
    }
  }

  if (!session_id) {
    session_id = uuidv4();
    const sessionData = {
      id: session_id,
      timestamp: now,
    };
    scopedLocalStorage.setItem("session_info", JSON.stringify(sessionData));
  }

  return session_id;
}
